export interface LatestLearningSection {
  lastProgress: string;
  lastTarget: string;
  lastAssessmentScore: string;
}
